import { DateRange, LegacyDateRange, RelativeDateRange, AbsoluteDateRange } from './types';

export const formatUTCDate = (date: Date) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[date.getUTCMonth()];
  const day = String(date.getUTCDate()).padStart(2, '0');
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  
  return `${month} ${day}, ${year} ${hours}:${minutes}`;
};

export const toUTCDayBoundary = (date: Date | null, isEndOfDay: boolean): Date | null => {
  if (!date) return null;
  return isEndOfDay
    ? new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59, 999))
    : new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0));
}

// Utility functions for handling dual-mode date ranges
export const computeRelativeDateRange = (value: number, unit: 'hours' | 'days'): LegacyDateRange => {
  const now = new Date();
  const millisecondsBack = unit === 'hours' 
    ? value * 60 * 60 * 1000 
    : value * 24 * 60 * 60 * 1000;
  
  const from = new Date(now.getTime() - millisecondsBack);
  
  return {
    from: new Date(Date.UTC(
      from.getUTCFullYear(),
      from.getUTCMonth(),
      from.getUTCDate(),
      from.getUTCHours(),
      from.getUTCMinutes(),
      0,
      0
    )),
    to: new Date(Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      59,
      999
    ))
  };
};

export const getDateRangeAsDates = (dateRange: DateRange): LegacyDateRange => {
  if (dateRange.mode === 'relative') {
    return computeRelativeDateRange(dateRange.value, dateRange.unit);
  }
  return { from: dateRange.from, to: dateRange.to };
};

export const createRelativeDateRange = (value: number, unit: 'hours' | 'days', label: string): RelativeDateRange => ({
  mode: 'relative',
  value,
  unit,
  label
});

export const createAbsoluteDateRange = (from: Date, to: Date): AbsoluteDateRange => ({
  mode: 'absolute',
  from,
  to
});